import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";
import { ChecklistSubitem } from "./Checklists";

export interface analiseFinalizada extends analisePendenteType {
  userFinalizador: string,
  userFinalizadorNome: string,
  rejeitada?: boolean,
  planosCriados?: string[],
  dataAnalise?: number
}

export interface analisePendenteType {
  dataCriacao: number;
  empresa: string;
  id: string;
  idExecucao: string;
  naoConformidades: ChecklistSubitem[];
  nomeForm: string;
}

export type logPlanoType = {
  acao: string;
  user: string;
  data: number;
  foto?: string;
};

export type taskType = {
  criadorNome?: string;
  responsavelNome?: string;
  nome: string;
  comentario?: string;
  status: "pendente" | "emExecucao" | "concluido" | "aprovado" | "rejeitado";
  responsavel: string;
  dataLimite: number;
  detalhes?: string;
  obrigatorioEvidencia: boolean;
  log?: logPlanoType[];
  fim?: number;
  id?: string;
};

export type planoDeAcaoType = {
  criadorNome?: string;
  criador?: string;
  naoConformidades: ChecklistSubitem[];
  nome: string;
  ocorrencia?: string;
  empresa: string;
  idExecucao: string;
  id?: string;
  responsavel: string;
  dataLimite: number;
  dataCriacao?: number;
  fim?: number;
  status: "aberto" | "fechado";
  avaliacao?: "pendente" | "malSucedido" | "bemSucedido";
  responsavelNome?: string;
  tasks: taskType[];
  avaliadorNome?: string;
  detalhesAvaliacao?: string;
  dataFechamento?: number;
  dataAvaliacao?: number;
  dataEdicao?: number;
  dataReinicio?: number;
  userReinicioNome?: number;
  userEditorNome?: string;
  editado?: boolean;
  formularioNome?: string;
};

class PlanoDeAcao {


  getPendingList = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getPendingList", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  startPlano = async (body: AuthBodyType, analiseId: string, planos: planoDeAcaoType[] | null) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/startPlano", {
        ...body,
        analiseId,
        planos,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  salvarGestoresPA = async (
    body: AuthBodyType,
    conjuntoId: string,
    listaGestoresPA?: { [usuarioId: string]: string[] },
    listaInspetoresPA?: { [usuarioId: string]: string[] }
  ) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/salvarGestoresPA", {
        ...body,
        conjuntoId,
        listaGestoresPA,
        listaInspetoresPA,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  getListaGestoresPA = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getListaGestoresPA", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  getPlansByUser = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getPlansByUser", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  changeStatusTask = async (
    body: AuthBodyType,
    acao: {
      taskIndex: number;
      comentario?: string;
      status: string;
      planoId: string;
      foto?: string;
    }
  ) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/changeStatusTask", {
        ...body,
        acao,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  finalizaPlano = async (body: AuthBodyType, planoId: string) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/finalizaPlano", {
        ...body,
        planoId,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  getListaInspetoresPA = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getListaInspetoresPA", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  getFileLink = async (body: AuthBodyType, fileRef: string) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getFileLink", {
        ...body,
        fileRef,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  getListForInspector = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getListForInspector", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

        // const dataError = error.response?.data as unknown as any;
        // const erro = dataError.message;
        // toast.error(String(erro));
      }
    }
  };

  evaluatePlan = async (body: AuthBodyType, planoId: string, avaliacao: string, detalhes: string) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/evaluatePlan", {
        ...body,
        planoId,
        avaliacao,
        detalhes
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  getFinishedList = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getFinishedList", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  getRefuseds = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getRefuseds", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  editPlan = async (body: AuthBodyType, plano: planoDeAcaoType, restarting: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/editPlan", {
        ...body,
        plano,
        restarting
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };

  getPlansById = async (body: AuthBodyType, planIds: string[]) => {
    try {
      const data: AxiosResponse = await api.post("/planoDeAcao/getPlansById", {
        ...body,
        planIds
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;

      }
    }
  };
}

export default PlanoDeAcao;
